import * as ProgressPrimitive from '@radix-ui/react-progress';
import clsx from 'clsx';
import { Text } from './Text';

export function Progress({ className, value, ...props }: ProgressPrimitive.ProgressProps) {
  return (
    <div className="gap-2xs flex items-center">
      <ProgressPrimitive.Root
        className={clsx(
          'bg-neutral-subtle h-sm border-brand-default relative w-full overflow-hidden rounded-full border p-[3px]',
          (value || 0) > 100 && 'border-error-default',
          className
        )}
        {...props}
      >
        <ProgressPrimitive.Indicator
          className={clsx(
            'bg-brand-default h-full flex-1 rounded-full transition-all',
            (value || 0) > 100 && 'bg-error-default'
          )}
          style={{ width: `${value ? (value > 100 ? 100 : value) : 0}%` }}
        />
      </ProgressPrimitive.Root>
      <Text variant="label" size="xs" strong>
        {Math.round(value || 0)}%
      </Text>
    </div>
  );
}
